var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"exit",on:{"click":function($event){return _vm.onExit()}}},[_vm._v("\n  "+_vm._s(_vm.$t('player.exitStation'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }